/** Interval tab config → Forecast API query params */
export const FORECAST_INTERVAL_TABS = [
  {
    id: '5min_2h',
    label: '5 Min / 2hr',
    from: 'now',
    to: '+2hours',
    interval: '5min',
    limit: 24,
  },
  {
    id: '1h_24h',
    label: '1 Hour / 24hr',
    from: 'now',
    to: '+24hours',
    interval: '1h',
    limit: 24,
  },
  {
    id: '6h_7d',
    label: '6 Hours / 7 days',
    from: 'today',
    to: '+7days',
    interval: '6h',
    limit: 28,
  },
  {
    id: '1d_7d',
    label: '1 day / 7 days',
    from: 'today',
    to: '+7days',
    interval: '24h',
    limit: 7,
  },
];

export const DEFAULT_FORECAST_INTERVAL = '6h_7d';

export function getIntervalConfig(intervalId) {
  return (
    FORECAST_INTERVAL_TABS.find((t) => t.id === intervalId) ??
    FORECAST_INTERVAL_TABS.find((t) => t.id === DEFAULT_FORECAST_INTERVAL)
  );
}
